import { ExtendedContactFormData } from "./types";

export const INITIAL_VALUES: ExtendedContactFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phoneCode: {
    alphaCode: "CH",
    code: "41",
  },
  phone: "",
  isSwissResidentConfirmed: false,
  isPrivacyPolicyConfirmed: false,
};

export const RECAPTCHA_ACTION = "extended_contact";
export const UNDEFINED_VALUE = "undefined";
export const TRUE = "yes";
export const FALSE = "no";
